interface Props {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  id?: string;
}

export default function SectionHeading({ eyebrow, title, description, align = "left", id }: Props) {
  const centered = align === "center";
  return (
    <div className={`${centered ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
          <span className="h-1 w-5 rounded-full bg-primary-500" aria-hidden="true"></span>
          {eyebrow}
        </span>
      )}
      <h2 id={id} className="mt-3 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {description && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>}
    </div>
  );
}